import { ref } from 'vue';
import { defineStore } from 'pinia';
import { getDeviceTypes } from '@/services/screen';

export const useAppStore = defineStore('app', () => {
    const screenNumber = ref(null);
    const sendEmailBlocked = ref(false);
    const sendEmailRequireBlock = ref(false);
    const sendEmailLoading = ref(false);
    const createEmailLoading = ref(false);

    function isRouteHidden (route) {
        if (!route.meta.hidden) return false;
        const deviceTypes = route.meta.hidden;
        const currentDevice = getDeviceTypes().filter(item => item.state === true)[0].name;
        return deviceTypes.includes(currentDevice);
    }

    function isRouteInMenu(route) {
        return !route.meta.hideOnMenu && !isRouteHidden(route);
    }

    return {
        screenNumber,
        sendEmailBlocked,
        sendEmailLoading,
        createEmailLoading,
        sendEmailRequireBlock,
        isRouteHidden,
        isRouteInMenu,
    }
});